import MOModalWrapper from "../../../../components/commons/MOModalWrapper";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import { CheckCircleOutline } from "@material-ui/icons";

const RevertOnboarding = ({
  modalOpen,
  setModalOpen,
  apiCall,
  callingStatus = false,
}) => {
  return (
    <MOModalWrapper
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title="Revert Back Onboarding"
      className={"small-medium-modal-section"}
    >
      <div className="mt-30">
        <div className="flex flex-col align-item-center">
          {/* <img src={DeleteIcon} alt="disconnection icon" /> */}
          <CheckCircleOutline
            className="text-primary"
            style={{
              fontSize: 40,
            }}
          />
          <h2 className="font-20 font-600 m-0 mt-24 ">Are You Sure?</h2>
          <p className="m-0 mt-8">Are you sure to approve this onboarding?</p>
          <div className="flex align-item-center justify-content-end mt-50 mb-56">
            <div className="mr-20">
              <MOButtonV2
                text="NO, Cancel"
                textColor="#1D2433"
                radius={7}
                backgroundColor="#ffffff"
                border="1px solid #E0E0E0"
                fontSize={12}
                height={38}
                onClick={() => {
                  setModalOpen(false);
                }}
              />
            </div>
            <div>
              <MOButtonV2
                text={callingStatus ? "Reverting..." : "YES, Revert Back"}
                textColor="#FCFCFD"
                radius={7}
                backgroundColor="#2CA9DD"
                fontSize={12}
                height={38}
                onClick={() => {
                  apiCall();
                }}
                disabled={callingStatus}
              />
            </div>
          </div>
        </div>
      </div>
    </MOModalWrapper>
  );
};

export default RevertOnboarding;
